const reload = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.029 13.161 1 15.19V10h5.19l-2.1 2.1a5.691 5.691 0 0 0 9.55-4.02l1.5.04a7.19 7.19 0 0 1-12.111 5.041M13.354 3.05 15 1.4v5.2H9.81l2.483-2.488A5.79 5.79 0 0 0 2.64 8.261l-1.5-.042a7.29 7.29 0 0 1 12.214-5.17"/></svg>',
};

export { reload as default };
